import _ from 'lodash';

_.templateSettings = { // LoDash template settings
	interpolate: /\{\{(.+?)\}\}/g,
	evaluate: /<@(.+?)@>/g
};

const _t = {

	topicLink: _.template('<li class="pers-topic-item" href="javascript:void(0)">{{ name }}</li>'),

	calculator: _.template('<div class="pers-calculators-name"><a href="{{ url }}">{{ title }}</a></div>'),

	calculatorButton: _.template('<a href="{{ view_button }}">VIEW ALL CALCULATORS</a>'),

	checkedtopicLink: _.template(`<li class="pers-topic-item">
										<div class="checkbox"></div>
										<div style="width: calc(100% - 30px); overflow: hidden;">
											{{ name }}
										</div>
									</li>`),

	uncheckedtopicLink: _.template(`<li class="pers-topic-item pers-box-shadow">
										<div class="uncheckbox"></div>
										<div style="width: calc(100% - 30px); overflow: hidden;">
											{{ name }}
										</div>
									</li>`),

	showMoreTopicButton: _.template('<a href="{{ show_more_button }}">SHOW MORE TOPICS</a>'),

	consultItem: _.template(`<li class="pers-posts-item">
					<a href="{{ uri }}">
						<img src="{{ imageUrl }}" class="pers-post-img">
						<div class="pers-post-name">{{ displayName }}</div>
						<div class="pers-post-text">{{ body }}</div>
						<div class="pers-post-footer">
							<div class="pers-post-replies-count">{{ repliesCount }} Replies</div>
							<div class="pers-post-respond-button">Respond</div>
						</div>
					</a>
					</li>`),

	cmeFeedPopup: _.template(`<div id="cme-overlay">
								<div class="cme-popup" id="cme-popup">
									<div class="cross" id="cme-popup-close"></div>
									<div class="cme-redirection-msg">You are being redirected to Medscape Education</div>
										<a href="{{ url }}" class="cme-redirection-button">
											<span class="content">Yes, take me there</span>
											<span class="progress">
											<span class="progress-inner"></span>
											</span>
										</a>
									<div class="cme-redirection-content">
										<div class="cme-redirection-content-subheader">{{ credits }}</div>
										<div class="cme-redirection-content-title">{{ title }}</div>
										<@ if (imageUrl != '') { @>
											<div class="cme-redirection-content-img">
												<img src="{{ imageUrl }}" class="pers-img">
											</div>
										<@ } @>
									</div>
								</div>
							</div>`),
							
	featuredComment : _.template(`<div class="featured-comments-wrap">
				<div class="featured-comments-bg">
					<div class="featured-comments-title">Featured Comment</div>
					<div class="featured-comments-name-specialty"><span class="featured-comments-name">{{ userName }}</span> <span class="featured-comments-specialty">{{ specialtyName }}</span></div>
					<div class="featured-comments-description">
						{{ featuredCommentsDescription }}
						<div class="featured-show-more"><span class="featured-ellipses">...</span> Show more</div>
					</div>
				</div>
			</div>`),
			
	rcLink: _.template('<a href="{{ url }}" class="rc-button {{ extraClass }}">{{ title }}</a>')

};

export default _t;